import { render, staticRenderFns } from "./symposiumdetail.vue?vue&type=template&id=116f1746&scoped=true&"
import script from "./symposiumdetail.vue?vue&type=script&lang=js&"
export * from "./symposiumdetail.vue?vue&type=script&lang=js&"
import style0 from "./symposiumdetail.vue?vue&type=style&index=0&id=116f1746&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f1746",
  null
  
)

component.options.__file = "symposiumdetail.vue"
export default component.exports